import React from "react";
import { useParams } from "react-router-dom";
import RegistrationsListView from "../Registrations/RegistrationsListView";
import "../../../css/View/VariantRegistrations.css";

const TripRegistrations = ({ registrations = [] }) => {
  const { guid: tripGuid } = useParams();

  return (
    <div className="trip-variant-section trip-variant-registrations">
      <RegistrationsListView registrations={registrations} registrationBasePath={`/trips/${tripGuid}/registrations`} />
    </div>
  );
};

export default TripRegistrations;
